import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, Box, Typography, Button, Paper, Grid, TextField, Autocomplete, Tabs, Tab, ButtonGroup, Card, CardMedia, CardContent, CardActions, Chip, Divider, Menu, MenuItem, useMediaQuery, useTheme, Avatar } from '@mui/material';
import { 
  Search, Brightness4, Brightness7, CarRental, DirectionsCar, Sell, Star, 
  PhotoCamera, Info, Lock, PersonAdd, Person, Business, Logout, Menu as MenuIcon,
  AccessTime, Check, LocalOffer 
} from '@mui/icons-material';
import './App.css';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, setDoc, getDoc, collection, getDocs, query, where } from 'firebase/firestore';
import { db } from './firebase-config';
import CarDetailsPage from './pages/CarDetailsPage';
import DealerPage from './components/DealerPage/DealerPage.jsx';
import NewCars from './pages/NewCars';
import UsedCars from './pages/UsedCars';
import Rentals from './pages/Rentals';
import PostAd from './pages/PostAd';
import UserPage from './pages/UserPage';
import AutoSalonPage from './pages/AutoSalonPage';
import AllCars from './pages/AllCars';
import AdminPage from './pages/AdminPage';
import AllSalons from './components/AllSalons/AllSalons';
import InputAdornment from '@mui/material/InputAdornment';
import PremiumListings from './components/PremiumListings/PremiumListings';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import Mail from '@mui/icons-material/Mail';
import { CircularProgress } from '@mui/material';
import EditAd from './pages/EditAd';

const AppWrapper = () => {
  return (
    <PayPalScriptProvider options={{
      "client-id": "ATtPnJXUd_ukWga_20JdkQUtgZ4_YrSYePHIMYXCJSRut0XEcILPvqVTbS-pKiuPWKeBeOBtbW1i93u1",
      currency: "CAD",
      components: "buttons,funding-eligibility"
    }}>
      <Router>
        <App />
      </Router>
    </PayPalScriptProvider>
  );
};

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [premiumCars, setPremiumCars] = useState([]);
  const [topDealers, setTopDealers] = useState([]);
  const [newListings, setNewListings] = useState([]);
  const [usedListings, setUsedListings] = useState([]);
  const [rentalListings, setRentalListings] = useState([]);
  const [searchFilters, setSearchFilters] = useState({
    brand: '',
    bodyType: '',
    city: '',
    maxPrice: ''
  });
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  const auth = getAuth();
  const brands = ['BMW', 'Mercedes', 'Audi', 'Tesla', 'Volkswagen'];
  const bodyTypes = ['Седан', 'SUV', 'Хечбек', 'Купе', 'Кабриолет'];
  const cities = [
    'Скопје', 'Битола', 'Прилеп', 'Куманово', 'Тетово', 'Охрид', 'Велес', 'Штип', 'Кавадарци', 'Гостивар',
    'Струмица', 'Неготино', 'Кочани', 'Кичево', 'Ресен', 'Гевгелија', 'Струга', 'Делчево', 'Виница', 'Кратово',
    'Крива Паланка', 'Берово', 'Македонски Брод', 'Дебар', 'Демир Капија', 'Демир Хисар', 'Пробиштип', 'Свети Николе',
    'Валандово', 'Богданци', 'Пехчево', 'Радовиш', 'Теарце', 'Желино', 'Липково', 'Чаир', 'Аеродром', 'Гази Баба',
    'Карпош', 'Кисела Вода', 'Центар', 'Ѓорче Петров', 'Сарај', 'Студеничани', 'Арачиново', 'Сопиште', 'Зелениково',
    'Илинден', 'Петровец', 'Чучер-Сандево', 'Зрновци', 'Маврово и Ростуше', 'Ранковце', 'Лозово', 'Новци', 'Новаци',
    'Конче', 'Дојран', 'Василево', 'Босилово', 'Ново Село', 'Карачиново', 'Куклиш', 'Могила', 'Пласница', 'Центар Жупа'
  ];

  const handleMobileMenuOpen = (event) => {
    setMobileMenuAnchor(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuAnchor(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const premiumQuery = query(collection(db, 'ads'), where('isPremium', '==', true));
        const premiumSnapshot = await getDocs(premiumQuery);
        const premiumData = premiumSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          price: doc.data().price ? doc.data().price + ' €' : 'N/A',
          mileage: doc.data().mileage ? doc.data().mileage + ' km' : '0 km'
        }));
        setPremiumCars(premiumData);

        const dealersQuery = query(
          collection(db, 'users'),
          where('userType', '==', 'dealer'),
          where('plan', '==', 'premium')
        );
        const dealersSnapshot = await getDocs(dealersQuery);
        const dealersData = await Promise.all(
          dealersSnapshot.docs.map(async (doc) => {
            const dealer = doc.data();
            const dealerId = doc.id;
        
            const adsQuery = query(collection(db, 'ads'), where('userId', '==', dealerId));
            const adsSnapshot = await getDocs(adsQuery);
        
            return {
              id: dealerId,
              ...dealer,
              logo: dealer.avatar || 'https://via.placeholder.com/150x80?text=Dealer+Logo',
              adsCount: adsSnapshot.size
            };
          })
        );
        setTopDealers(dealersData);

        const newQuery = query(collection(db, 'ads'), where('carType', '==', 'new'), where('status', '==', 'active'));
        const newSnapshot = await getDocs(newQuery);
        const newData = newSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          price: doc.data().price ? doc.data().price + ' €' : 'N/A'
        }));
        setNewListings(newData);

        const usedQuery = query(collection(db, 'ads'), where('carType', '==', 'used'), where('status', '==', 'active'));
        const usedSnapshot = await getDocs(usedQuery);
        const usedData = usedSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          price: doc.data().price ? doc.data().price + ' €' : 'N/A',
          mileage: doc.data().mileage ? doc.data().mileage + ' km' : 'N/A'
        }));
        setUsedListings(usedData);

        const rentalQuery = query(collection(db, 'ads'), where('adType', '==', 'rent'), where('status', '==', 'active'));
        const rentalSnapshot = await getDocs(rentalQuery);
        const rentalData = rentalSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          price: typeof doc.data().dailyPrice === 'number' ? `${doc.data().dailyPrice} €/ден` : 'N/A',
          mileage: typeof doc.data().mileage === 'number' ? `${doc.data().mileage} km` : 'N/A'
        }));
        setRentalListings(rentalData);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setUserData(userDoc.data());
        }
      } else {
        setUserData(null);
      }
      setIsAuthChecked(true);
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    const queryParams = new URLSearchParams();
    if (searchFilters.brand) queryParams.append('brand', searchFilters.brand);
    if (searchFilters.bodyType) queryParams.append('type', searchFilters.bodyType);
    if (searchFilters.city) queryParams.append('city', searchFilters.city);
    if (searchFilters.maxPrice) queryParams.append('maxPrice', searchFilters.maxPrice);
    
    window.location.href = `/all-cars?${queryParams.toString()}`;
  };

  const handleFilterChange = (name, value) => {
    setSearchFilters(prev => ({
      ...prev,
      [name]: value || ''
    }));
  };

  // Login Page Component
  const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/post-ad';
  
    const handleLogin = async (e) => {
      e.preventDefault();
      setError('');
      
      if (!email || !password) {
        setError('Внесете ги сите потребни податоци');
        return;
      }
  
      setIsLoading(true);
  
      try {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
  
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          if ((userData.role || '').toLowerCase() === 'admin') {
            navigate('/admin');
          } else if ((userData.userType || '').toLowerCase() === 'dealer') {
            navigate('/avtosalon');
          } else {
            navigate('/user');
          }
        } else {
          navigate('/user');
        }
  
      } catch (err) {
        console.error('Грешка при најава:', err);
        switch (err.code) {
          case 'auth/invalid-email':
            setError('Невалидна е-пошта');
            break;
          case 'auth/user-not-found':
            setError('Корисникот не постои');
            break;
          case 'auth/wrong-password':
            setError('Погрешна лозинка');
            break;
          default:
            setError('Грешка при најава. Обидете се повторно.');
        }
      } finally {
        setIsLoading(false);
      }
    };
  
    return (
      <Box sx={{ maxWidth: '400px', mx: 'auto', mt: 8, p: 3 }}>
        <Paper sx={{ p: 4 }}>
          <Typography variant="h5" sx={{ mb: 3, textAlign: 'center' }}>
            <Lock sx={{ mr: 1 }} /> Најава
          </Typography>
          
          {error && (
            <Typography color="error" sx={{ mb: 2, textAlign: 'center' }}>
              {error}
            </Typography>
          )}
  
          <form onSubmit={handleLogin}>
            <TextField 
              label="Е-пошта"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth 
              sx={{ mb: 2 }}
              required
              disabled={isLoading}
            />
            <TextField 
              label="Лозинка"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth 
              sx={{ mb: 3 }}
              required
              disabled={isLoading}
            />
            <Button 
              type="submit"
              variant="contained"
              fullWidth
              disabled={isLoading}
              sx={{ 
                background: 'linear-gradient(45deg, #3a86ff, #4361ee)',
                py: 1.5
              }}
            >
              {isLoading ? 'Се најавувам...' : 'Најави се'}
            </Button>
          </form>

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Typography variant="body2">
              Немате профил? <Button component={Link} to="/register" color="primary" disabled={isLoading}>Регистрирај се тука</Button>
            </Typography>
          </Box>
        </Paper>
      </Box>
    );
  };

  // Register Page Component
  const RegisterPage = () => {
    const [userType, setUserType] = useState('private');
    const [formData, setFormData] = useState({
      name: '',
      email: '',
      password: '',
      dealerName: '',
      city: ''
    });
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const validateForm = () => {
      if (!formData.email.includes('@')) {
        setError('Невалидна е-пошта');
        return false;
      }
      if (formData.password.length < 6) {
        setError('Лозинката мора да има најмалку 6 знаци');
        return false;
      }
      if (userType === 'dealer' && !formData.dealerName.trim()) {
        setError('Внесете име на автосалон');
        return false;
      }
      if (!formData.city) {
        setError('Изберете град');
        return false;
      }
      return true;
    };

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setError('');
      
      if (!validateForm()) return;
      
      setIsSubmitting(true);

      try {
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          formData.email,
          formData.password
        );
        
        await setDoc(doc(db, "users", userCredential.user.uid), {
          name: formData.name,
          email: formData.email,
          userType,
          city: formData.city,
          createdAt: new Date(),
          ...(userType === 'dealer' && { 
            dealerName: formData.dealerName,
            role: 'dealer',
            dealerSlug: formData.dealerName.toLowerCase().trim().replace(/\s+/g, '-')
          })
        });

        if (userType === 'dealer') {
          navigate('/autosalon');
        } else {
          navigate('/user');
        }

      } catch (err) {
        console.error('Грешка при регистрација:', err);
        switch (err.code) {
          case 'auth/email-already-in-use':
            setError('Е-поштата е веќе регистрирана');
            break;
          case 'auth/invalid-email':
            setError('Невалидна е-пошта');
            break;
          case 'auth/weak-password':
            setError('Лозинката мора да има најмалку 6 знаци');
            break;
          default:
            setError('Грешка при регистрација. Обидете се повторно.');
        }
      } finally {
        setIsSubmitting(false);
      }
    };

    return (
      <Box sx={{ maxWidth: '600px', mx: 'auto', mt: 4, p: 3 }}>
        <Paper sx={{ p: 4, borderRadius: '12px', boxShadow: '0 8px 24px rgba(0,0,0,0.1)' }}>
          <Typography variant="h4" sx={{ mb: 3, textAlign: 'center', fontWeight: 'bold', color: 'primary.main' }}>
            <PersonAdd sx={{ mr: 1, verticalAlign: 'middle' }} /> Регистрација
          </Typography>

          {error && (
            <Typography color="error" sx={{ mb: 2, textAlign: 'center' }}>
              {error}
            </Typography>
          )}

          <Box sx={{ mb: 4, textAlign: 'center' }}>
            <Typography variant="h6" sx={{ mb: 3, color: 'text.secondary' }}>
              Регистрирај се како:
            </Typography>
            
            <Grid container spacing={3} sx={{ mb: 2 }}>
              <Grid item xs={6}>
                <Card 
                  onClick={() => setUserType('private')}
                  sx={{ 
                    p: 2,
                    cursor: 'pointer',
                    border: userType === 'private' ? '2px solid #3a86ff' : '1px solid #e0e0e0',
                    borderRadius: '12px',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 6px 12px rgba(0,0,0,0.1)'
                    }
                  }}
                >
                  <Box sx={{ 
                    height: '120px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2
                  }}>
                    <img 
                      src="/images/privaten.png" 
                      alt="Приватен продавач" 
                      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                    />
                  </Box>
                  <Button
                    fullWidth
                    variant={userType === 'private' ? 'contained' : 'outlined'}
                    sx={{
                      bgcolor: userType === 'private' ? '#3a86ff' : 'transparent',
                      color: userType === 'private' ? '#fff' : 'text.primary',
                      '&:hover': {
                        bgcolor: userType === 'private' ? '#2667cc' : 'action.hover'
                      }
                    }}
                  >
                    Приватен продавач
                  </Button>
                </Card>
              </Grid>
              
              <Grid item xs={6}>
                <Card 
                  onClick={() => setUserType('dealer')}
                  sx={{ 
                    p: 2,
                    cursor: 'pointer',
                    border: userType === 'dealer' ? '2px solid #3a86ff' : '1px solid #e0e0e0',
                    borderRadius: '12px',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 6px 12px rgba(0,0,0,0.1)'
                    }
                  }}
                >
                  <Box sx={{ 
                    height: '120px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2
                  }}>
                    <img 
                      src="/images/salon.png" 
                      alt="Авто салон" 
                      style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                    />
                  </Box>
                  <Button
                    fullWidth
                    variant={userType === 'dealer' ? 'contained' : 'outlined'}
                    sx={{
                      bgcolor: userType === 'dealer' ? '#3a86ff' : 'transparent',
                      color: userType === 'dealer' ? '#fff' : 'text.primary',
                      '&:hover': {
                        bgcolor: userType === 'dealer' ? '#2667cc' : 'action.hover'
                      }
                    }}
                  >
                    Авто салон
                  </Button>
                </Card>
              </Grid>
            </Grid>
          </Box>

          <form onSubmit={handleSubmit}>
            {userType === 'dealer' && (
              <TextField
                label="Име на автосалон"
                name="dealerName"
                value={formData.dealerName}
                onChange={handleInputChange}
                fullWidth
                sx={{ mb: 3 }}
                required
                disabled={isSubmitting}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Business color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            )}

            <TextField 
              label={userType === 'private' ? "Вашето име" : "Контакт лице"} 
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              fullWidth 
              sx={{ mb: 3 }} 
              required
              disabled={isSubmitting}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Person color="action" />
                  </InputAdornment>
                ),
              }}
            />
            
            <TextField 
              label="Е-пошта" 
              name="email"
              type="email"
              value={formData.email}
              onChange={handleInputChange}
              fullWidth 
              sx={{ mb: 3 }} 
              required
              disabled={isSubmitting}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Mail color="action" />
                  </InputAdornment>
                ),
              }}
            />
            
            <TextField 
              label="Лозинка" 
              name="password"
              type="password" 
              value={formData.password}
              onChange={handleInputChange}
              fullWidth 
              sx={{ mb: 3 }} 
              required
              inputProps={{ minLength: 6 }}
              disabled={isSubmitting}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock color="action" />
                  </InputAdornment>
                ),
              }}
            />

            <Autocomplete
              options={cities}
              value={formData.city}
              onChange={(event, newValue) => {
                setFormData(prev => ({
                  ...prev,
                  city: newValue
                }));
              }}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  label="Град" 
                  required
                  sx={{ mb: 3 }}
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <InputAdornment position="start">
                        <Business color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              disableClearable
              disabled={isSubmitting}
            />
            
            <Button 
              type="submit"
              variant="contained" 
              fullWidth
              disabled={isSubmitting}
              sx={{ 
                background: 'linear-gradient(45deg, #3a86ff, #4361ee)',
                py: 2,
                color: '#fff',
                fontSize: '1rem',
                fontWeight: 'bold',
                borderRadius: '8px',
                mt: 2,
                '&:hover': {
                  background: 'linear-gradient(45deg, #2667cc, #3a56d6)',
                  boxShadow: '0 4px 12px rgba(58,134,255,0.3)'
                }
              }}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Регистрирај се'
              )}
            </Button>
          </form>

          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Веќе имате профил?{' '}
              <Link 
                component={Link} 
                to="/login" 
                sx={{ 
                  color: 'primary.main',
                  fontWeight: 'medium',
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Најавете се
              </Link>
            </Typography>
          </Box>
        </Paper>
      </Box>
    );
  };

  // Layout component that includes Navbar and Footer
  const Layout = ({ children }) => {
    const navigate = useNavigate();

    const handlePostAdClick = () => {
      if (!currentUser) {
        navigate('/login', { state: { from: { pathname: '/post-ad' } } });
      } else {
        navigate('/post-ad');
      }
    };

    return (
      <div className={`app ${darkMode ? 'dark' : 'light'}`}>
        <AppBar position="static" sx={{ 
          background: darkMode ? '#121212' : '#ffffff',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          borderBottom: darkMode ? '1px solid #333' : '1px solid #f0f0f0',
          py: 0.5
        }}>
          <Toolbar sx={{ 
            maxWidth: '1200px', 
            margin: '0 auto', 
            width: '100%', 
            px: { xs: 2, md: 4 },
            py: 1
          }}>
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              flexGrow: 1,
              gap: { xs: 1, md: 3 }
            }}>
              {/* Mobile Menu Button */}
              {isMobile && (
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  onClick={handleMobileMenuOpen}
                  sx={{ 
                    mr: 1,
                    color: darkMode ? '#fff' : '#333',
                    display: { xs: 'block', md: 'none' }
                  }}
                >
                  <MenuIcon />
                </IconButton>
              )}

              {/* Logo */}
              <Typography 
                variant="h6" 
                component={Link} 
                to="/"
                sx={{ 
                  fontWeight: 700,
                  fontSize: { xs: '1.1rem', md: '1.25rem' },
                  color: darkMode ? '#fff' : '#333',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  '&:hover': {
                    color: '#3a86ff'
                  }
                }}
              >
                <span style={{ color: '#3a86ff' }}>Avto</span>Klik
              </Typography>
              
              {/* Desktop Navigation */}
              {!isMobile && (
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  gap: 1,
                  ml: 2
                }}>
                  <Button 
                    component={Link} 
                    to="/premium" 
                    sx={{ 
                      color: darkMode ? '#fff' : '#333',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                      textTransform: 'none',
                      px: 1.5,
                      py: 0.5,
                      minWidth: 'auto',
                      '&:hover': {
                        color: '#3a86ff',
                        backgroundColor: 'transparent'
                      }
                    }}
                  >
                    Премиум Автомобили
                  </Button>
                  <Button 
                    component={Link} 
                    to="/all-cars" 
                    sx={{ 
                      color: darkMode ? '#fff' : '#333',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                      textTransform: 'none',
                      px: 1.5,
                      py: 0.5,
                      minWidth: 'auto',
                      '&:hover': {
                        color: '#3a86ff',
                        backgroundColor: 'transparent'
                      }
                    }}
                  >
                    Сите Возила
                  </Button>
                  <Button 
                    component={Link} 
                    to="/rentals" 
                    sx={{ 
                      color: darkMode ? '#fff' : '#333',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                      textTransform: 'none',
                      px: 1.5,
                      py: 0.5,
                      minWidth: 'auto',
                      '&:hover': {
                        color: '#3a86ff',
                        backgroundColor: 'transparent'
                      }
                    }}
                  >
                    Изнајмување
                  </Button>
                  <Button 
                    component={Link} 
                    to="/all-salons" 
                    sx={{ 
                      color: darkMode ? '#fff' : '#333',
                      fontWeight: 500,
                      fontSize: '0.875rem',
                      textTransform: 'none',
                      px: 1.5,
                      py: 0.5,
                      minWidth: 'auto',
                      '&:hover': {
                        color: '#3a86ff',
                        backgroundColor: 'transparent'
                      }
                    }}
                  >
                    Авто Салони
                  </Button>
                </Box>
              )}
            </Box>
            
            {/* Right Side Actions */}
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: { xs: 0.5, md: 1.5 }
            }}>
              <IconButton 
                onClick={() => setDarkMode(!darkMode)} 
                size="small"
                sx={{ 
                  color: darkMode ? '#3a86ff' : '#555',
                  '&:hover': {
                    backgroundColor: darkMode ? 'rgba(58,134,255,0.1)' : 'rgba(0,0,0,0.05)'
                  }
                }}
              >
                {darkMode ? <Brightness7 fontSize="small" /> : <Brightness4 fontSize="small" />}
              </IconButton>
              
              {!currentUser ? (
                <>
                  <Button 
                    component={Link} 
                    to="/login" 
                    variant="text"
                    size="small"
                    sx={{ 
                      color: '#3a86ff',
                      fontWeight: 500,
                      fontSize: '0.8125rem',
                      textTransform: 'none',
                      px: 1.5,
                      '&:hover': {
                        backgroundColor: 'rgba(58,134,255,0.1)'
                      }
                    }}
                  >
                    Најава
                  </Button>
                  <Button 
                    component={Link} 
                    to="/register" 
                    variant="contained"
                    size="small"
                    sx={{ 
                      background: 'linear-gradient(45deg, #3a86ff, #4361ee)',
                      color: '#fff',
                      fontWeight: 500,
                      fontSize: '0.8125rem',
                      textTransform: 'none',
                      px: 2,
                      py: 0.5,
                      '&:hover': {
                        background: 'linear-gradient(45deg, #2667cc, #3a56d6)'
                      }
                    }}
                  >
                    Регистрација
                  </Button>
                </>
              ) : (
                <>
                  <Button 
                    component={Link} 
                    to={userData?.userType === 'dealer' ? "/autosalon" : "/user"} 
                    variant="text"
                    size="small"
                    sx={{ 
                      color: darkMode ? '#fff' : '#333',
                      fontWeight: 500,
                      fontSize: '0.8125rem',
                      textTransform: 'none',
                      px: 1.5,
                      '&:hover': {
                        color: '#3a86ff',
                        backgroundColor: 'transparent'
                      }
                    }}
                    startIcon={userData?.userType === 'dealer' ? <Business fontSize="small" /> : <Person fontSize="small" />}
                  >
                    {isMobile ? '' : (userData?.userType === 'dealer' ? userData?.dealerName || 'Автосалон' : userData?.name || 'Профил')}
                  </Button>
                  <Button 
                    onClick={handleLogout}
                    variant="text"
                    size="small"
                    sx={{ 
                      color: darkMode ? '#fff' : '#333',
                      fontWeight: 500,
                      fontSize: '0.8125rem',
                      textTransform: 'none',
                      px: 1.5,
                      '&:hover': {
                        color: '#3a86ff',
                        backgroundColor: 'transparent'
                      }
                    }}
                    startIcon={<Logout fontSize="small" />}
                  >
                    {isMobile ? '' : 'Одјави се'}
                  </Button>
                </>
              )}
              <Button 
                variant="contained"
                size="small"
                sx={{ 
                  background: 'linear-gradient(45deg, #3a86ff, #4361ee)',
                  color: '#fff',
                  fontWeight: 500,
                  fontSize: '0.75rem',
                  textTransform: 'none',
                  px: 1.5,
                  py: 0.4,
                  minWidth: 0,
                  '&:hover': {
                    background: 'linear-gradient(45deg, #2667cc, #3a56d6)'
                  }
                }}
                startIcon={<Sell fontSize="small" />}
                onClick={handlePostAdClick}
              >
                {isMobile ? <Sell fontSize="small" /> : 'Објави Оглас'}
              </Button>
            </Box>
          </Toolbar>

          {/* Mobile Menu */}
          <Menu
            anchorEl={mobileMenuAnchor}
            open={Boolean(mobileMenuAnchor)}
            onClose={handleMobileMenuClose}
            PaperProps={{
              sx: {
                width: '100vw',
                maxWidth: '320px',
                background: darkMode ? '#333' : '#fff',
                right: 0,
                left: 'auto'
              }
            }}
          >
            <MenuItem 
              component={Link} 
              to="/premium" 
              onClick={handleMobileMenuClose}
              sx={{
                color: darkMode ? '#fff' : '#333',
                fontSize: '0.875rem',
                '&:hover': {
                  color: '#3a86ff'
                }
              }}
            >
              Премиум Автомобили
            </MenuItem>
            <MenuItem 
              component={Link} 
              to="/all-cars" 
              onClick={handleMobileMenuClose}
              sx={{
                color: darkMode ? '#fff' : '#333',
                fontSize: '0.875rem',
                '&:hover': {
                  color: '#3a86ff'
                }
              }}
            >
              Сите Возила
            </MenuItem>
            <MenuItem 
              component={Link} 
              to="/rentals" 
              onClick={handleMobileMenuClose}
              sx={{
                color: darkMode ? '#fff' : '#333',
                fontSize: '0.875rem',
                '&:hover': {
                  color: '#3a86ff'
                }
              }}
            >
              Изнајмување
            </MenuItem>
            <MenuItem 
              component={Link} 
              to="/all-salons" 
              onClick={handleMobileMenuClose}
              sx={{
                color: darkMode ? '#fff' : '#333',
                fontSize: '0.875rem',
                '&:hover': {
                  color: '#3a86ff'
                }
              }}
            >
              Авто Салони
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            {currentUser && (
              <>
                <MenuItem 
                  component={Link} 
                  to={userData?.userType === 'dealer' ? "/autosalon" : "/user"} 
                  onClick={handleMobileMenuClose}
                  sx={{
                    color: darkMode ? '#fff' : '#333',
                    fontSize: '0.875rem',
                    '&:hover': {
                      color: '#3a86ff'
                    }
                  }}
                >
                  Мој Профил
                </MenuItem>
                <MenuItem 
                  onClick={() => {
                    handleMobileMenuClose();
                    handleLogout();
                  }}
                  sx={{
                    color: darkMode ? '#fff' : '#333',
                    fontSize: '0.875rem',
                    '&:hover': {
                      color: '#3a86ff'
                    }
                  }}
                >
                  Одјави се
                </MenuItem>
                <MenuItem 
                  onClick={() => {
                    handleMobileMenuClose();
                    handlePostAdClick();
                  }}
                  sx={{
                    color: darkMode ? '#fff' : '#333',
                    fontSize: '0.875rem',
                    '&:hover': {
                      color: '#3a86ff'
                    }
                  }}
                >
                  Објави Оглас
                </MenuItem>
              </>
            )}
          </Menu>
        </AppBar>

        <main>
          {children}
        </main>

        <Box sx={{ 
          py: 4,
          background: darkMode ? '#121212' : '#f5f5f5',
          borderTop: darkMode ? '1px solid #333' : '1px solid #eee'
        }}>
          <Box sx={{ 
            maxWidth: '1200px', 
            mx: 'auto', 
            px: 4,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Typography sx={{ 
              color: darkMode ? '#aaa' : '#666', 
              mb: { xs: 2, md: 0 },
              fontSize: '0.8rem'
            }}>
              © 2025 AvtoKlik. Сите права се задржани.
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              gap: { xs: 1, md: 2 },
              flexWrap: 'wrap',
              justifyContent: { xs: 'center', md: 'flex-end' }
            }}>
              <Button 
                component={Link} 
                to="/terms" 
                sx={{ 
                  color: darkMode ? '#aaa' : '#666',
                  fontSize: '0.8rem',
                  minWidth: 'auto',
                  px: 1,
                  '&:hover': {
                    color: '#3a86ff',
                    backgroundColor: 'transparent'
                  }
                }}
              >
                Услови на Користење
              </Button>
              <Button 
                component={Link} 
                to="/privacy" 
                sx={{ 
                  color: darkMode ? '#aaa' : '#666',
                  fontSize: '0.8rem',
                  minWidth: 'auto',
                  px: 1,
                  '&:hover': {
                    color: '#3a86ff',
                    backgroundColor: 'transparent'
                  }
                }}
              >
                Политика за Приватност
              </Button>
              <Button 
                component={Link} 
                to="/contact" 
                sx={{ 
                  color: darkMode ? '#aaa' : '#666',
                  fontSize: '0.8rem',
                  minWidth: 'auto',
                  px: 1,
                  '&:hover': {
                    color: '#3a86ff',
                    backgroundColor: 'transparent'
                  }
                }}
              >
                Контакт
              </Button>
            </Box>
          </Box>
        </Box>
      </div>
    );
  };

  // Home component with all the content
  const Home = () => {
    const tabListings = {
      0: [...newListings, ...usedListings, ...rentalListings].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
      1: newListings,
      2: usedListings,
      3: rentalListings
    };

    return (
      <Box sx={{ 
        position: 'relative',
        overflow: 'hidden',
        background: darkMode ? '#121212' : '#f9f9f9'
      }}>
        {/* Hero Section - Futuristic Design */}
        <Box sx={{ 
          position: 'relative',
          height: { xs: '500px', md: '600px' },
          background: darkMode ? 'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7))' : 'linear-gradient(rgba(255,255,255,0.1), rgba(255,255,255,0.1))',
          backgroundImage: 'url(https://source.unsplash.com/random/1600x800/?car,future)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: darkMode ? 'rgba(0,0,0,0.6)' : 'rgba(255,255,255,0.3)',
            zIndex: 1
          }
        }}>
          <Box sx={{ 
            position: 'relative',
            zIndex: 2,
            maxWidth: '1200px',
            width: '100%',
            px: 3
          }}>
            <Typography variant="h2" sx={{ 
              fontWeight: 'bold',
              mb: 3,
              color: '#fff',
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              textShadow: '0 2px 10px rgba(0,0,0,0.5)',
              lineHeight: 1.2
            }}>
              Откријте го <span style={{ color: '#3a86ff' }}>идниот</span> ваш автомобил
            </Typography>
            
            <Typography variant="h5" sx={{ 
              mb: 4,
              color: '#fff',
              fontSize: { xs: '1.2rem', md: '1.5rem' },
              textShadow: '0 1px 5px rgba(0,0,0,0.5)'
            }}>
              Најдете ги најдобрите автомобили во Македонија
            </Typography>

            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              gap: 2,
              mt: 4,
              flexWrap: 'wrap'
            }}>
              <Button 
                component={Link}
                to="/new"
                variant="contained"
                size="large"
                sx={{
                  minWidth: '180px',
                  background: 'linear-gradient(45deg, #3a86ff, #4361ee)',
                  color: '#fff',
                  fontWeight: '600',
                  fontSize: '1rem',
                  py: 1.5,
                  borderRadius: '12px',
                  boxShadow: '0 5px 15px rgba(58,134,255,0.4)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #2667cc, #3a56d6)',
                    transform: 'translateY(-2px)'
                  },
                  transition: 'all 0.3s'
                }}
              >
                Нови Автомобили
              </Button>
              
              <Button 
                component={Link}
                to="/used"
                variant="contained"
                size="large"
                sx={{
                  minWidth: '180px',
                  background: 'linear-gradient(45deg, #7209b7, #560bad)',
                  color: '#fff',
                  fontWeight: '600',
                  fontSize: '1rem',
                  py: 1.5,
                  borderRadius: '12px',
                  boxShadow: '0 5px 15px rgba(114,9,183,0.4)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #5d0895, #450988)',
                    transform: 'translateY(-2px)'
                  },
                  transition: 'all 0.3s'
                }}
              >
                Половни Автомобили
              </Button>
              
              <Button 
                component={Link}
                to="/rentals"
                variant="contained"
                size="large"
                sx={{
                  minWidth: '180px',
                  background: 'linear-gradient(45deg, #f72585, #b5179e)',
                  color: '#fff',
                  fontWeight: '600',
                  fontSize: '1rem',
                  py: 1.5,
                  borderRadius: '12px',
                  boxShadow: '0 5px 15px rgba(247,37,133,0.4)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #d61f74, #9b1487)',
                    transform: 'translateY(-2px)'
                  },
                  transition: 'all 0.3s'
                }}
              >
                Изнајмување
              </Button>
            </Box>
          </Box>

          {/* Floating elements for futuristic feel */}
          <Box sx={{
            position: 'absolute',
            top: '20%',
            left: '10%',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            background: 'rgba(58,134,255,0.3)',
            filter: 'blur(20px)',
            zIndex: 1,
            animation: 'float 8s ease-in-out infinite'
          }} />
          <Box sx={{
            position: 'absolute',
            bottom: '15%',
            right: '15%',
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            background: 'rgba(247,37,133,0.3)',
            filter: 'blur(25px)',
            zIndex: 1,
            animation: 'float 10s ease-in-out infinite 2s'
          }} />
        </Box>

        {/* Premium Listings Section - Redesigned */}
        <Box sx={{ 
          py: 8, 
          maxWidth: '1400px', 
          mx: 'auto', 
          px: { xs: 2, md: 4 },
          position: 'relative'
        }}>
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: darkMode 
              ? 'radial-gradient(circle at 20% 30%, rgba(58,134,255,0.1) 0%, transparent 50%)' 
              : 'radial-gradient(circle at 20% 30%, rgba(58,134,255,0.05) 0%, transparent 50%)',
            zIndex: 0
          }} />
          
          <Box sx={{ 
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 6,
            position: 'relative',
            zIndex: 1,
            flexDirection: { xs: 'column', sm: 'row' },
            textAlign: { xs: 'center', sm: 'left' }
          }}>
            <Box>
              <Typography variant="h4" sx={{ 
                fontWeight: 'bold',
                color: darkMode ? '#fff' : '#333',
                mb: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: { xs: 'center', sm: 'flex-start' }
              }}>
                <Box sx={{ 
                  background: '#FFD700',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 2
                }}>
                  <Star sx={{ color: '#fff' }} />
                </Box>
                Премиум Огласи
              </Typography>
              <Typography variant="body1" sx={{ 
                color: darkMode ? '#aaa' : '#666',
                fontSize: { xs: '0.9rem', md: '1rem' }
              }}>
                Исклучителни автомобили од нашите најдобри партнери
              </Typography>
            </Box>
            <Button 
              component={Link}
              to="/premium"
              variant="outlined"
              sx={{ 
                color: '#FFD700',
                borderColor: '#FFD700',
                fontWeight: '600',
                px: 3,
                py: 1,
                borderRadius: '12px',
                mt: { xs: 2, sm: 0 },
                '&:hover': { 
                  borderColor: '#FFD700',
                  background: 'rgba(255,215,0,0.1)'
                }
              }}
            >
              Види ги сите
            </Button>
          </Box>
          
          <Grid container spacing={3} sx={{ position: 'relative', zIndex: 1 }}>
            {premiumCars.slice(0, 6).map((car) => (
              <Grid item xs={12} sm={6} md={4} lg={2} key={car.id}>
                <Card sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: 'none',
                  background: darkMode ? '#1e1e1e' : '#fff',
                  boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
                  }
                }}>
                  <Box sx={{
                    position: 'relative',
                    height: '140px',
                    overflow: 'hidden'
                  }}>
                    <CardMedia
                      component="img"
                      height="140"
                      image={
                        car.coverImage ||
                        (car.images && car.images.length > 0
                          ? car.images?.[car.coverPhotoIndex || 0]
                          : 'https://source.unsplash.com/random/600x400/?car,luxury')
                      }
                      alt={car.model}
                      sx={{ 
                        objectFit: 'cover',
                        transition: 'transform 0.5s',
                        '&:hover': {
                          transform: 'scale(1.1)'
                        }
                      }}
                    />
                    <Box sx={{
                      position: 'absolute',
                      top: 8,
                      left: 8,
                      background: 'rgba(0,0,0,0.7)',
                      color: '#fff',
                      px: 1.2,
                      py: 0.3,
                      borderRadius: '50px',
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      <Star sx={{ 
                        color: '#FFD700',
                        fontSize: '0.9rem',
                        mr: 0.5
                      }} />
                      <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '0.7rem' }}>
                        Премиум
                      </Typography>
                    </Box>
                  </Box>
                  <CardContent sx={{ flexGrow: 1, p: 2 }}>
                    <Box sx={{ 
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'flex-start',
                      mb: 1
                    }}>
                      <Box>
                        <Typography variant="subtitle1" sx={{ 
                          fontWeight: 'bold',
                          color: darkMode ? '#fff' : '#333',
                          fontSize: '0.9rem',
                          lineHeight: 1.2,
                          mb: 0.5
                        }}>
                          {car.brand} {car.model}
                        </Typography>
                        <Typography variant="body2" sx={{ 
                          color: darkMode ? '#aaa' : '#666',
                          fontSize: '0.75rem'
                        }}>
                          {car.year} год.
                        </Typography>
                      </Box>
                      <Avatar 
                        sx={{ 
                          width: 32, 
                          height: 32,
                          bgcolor: car.sellerType === 'dealer' ? '#4CAF50' : '#7209b7',
                          fontSize: '0.9rem',
                          fontWeight: 'bold'
                        }}
                      >
                        {car.sellerType === 'dealer' ? 
                          (car.dealerName ? car.dealerName.charAt(0).toUpperCase() : 'A') : 
                          (car.sellerName ? car.sellerName.charAt(0).toUpperCase() : 'P')}
                      </Avatar>
                    </Box>
                    
                    <Typography variant="body1" sx={{ 
                      color: '#3a86ff',
                      fontWeight: 'bold',
                      fontSize: '1rem',
                      mb: 1,
                      mt: 1
                    }}>
                      {car.price}
                    </Typography>
                    
                    <Box sx={{ 
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: 0.5,
                      mb: 1
                    }}>
                      <Chip 
                        label={car.mileage}
                        size="small"
                        sx={{ 
                          background: darkMode ? '#333' : '#f0f0f0',
                          color: darkMode ? '#fff' : '#333',
                          fontSize: '0.65rem',
                          height: '20px'
                        }}
                      />
                      <Chip 
                        label={car.fuelType}
                        size="small"
                        sx={{ 
                          background: darkMode ? '#333' : '#f0f0f0',
                          color: darkMode ? '#fff' : '#333',
                          fontSize: '0.65rem',
                          height: '20px'
                        }}
                      />
                    </Box>
                    
                    <Box sx={{ 
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mt: 'auto'
                    }}>
                      <Typography variant="body2" sx={{ 
                        color: darkMode ? '#aaa' : '#666',
                        fontSize: '0.7rem'
                      }}>
                        {car.city}
                      </Typography>
                      <Typography variant="body2" sx={{ 
                        color: darkMode ? '#aaa' : '#666',
                        fontSize: '0.7rem'
                      }}>
                        {car.sellerType === 'dealer' ? 'Автосалон' : 'Приватно'}
                      </Typography>
                    </Box>
                  </CardContent>
                  <CardActions sx={{ p: 2, pt: 0 }}>
                    <Button 
                      component={Link}
                      to={`/cars/${car.id}`}
                      fullWidth 
                      variant="contained"
                      size="small"
                      sx={{
                        background: 'linear-gradient(45deg, #3a86ff, #4361ee)',
                        color: '#fff',
                        fontWeight: '600',
                        py: 0.5,
                        fontSize: '0.75rem',
                        borderRadius: '6px',
                        '&:hover': {
                          background: 'linear-gradient(45deg, #2667cc, #3a56d6)'
                        }
                      }}
                    >
                      Види Детали
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Verified Dealers Section - Redesigned */}
        <Box sx={{ 
          py: 8, 
          background: darkMode ? '#1a1a1a' : '#f5f5f5',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Box sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '300px',
            height: '300px',
            background: darkMode 
              ? 'radial-gradient(circle, rgba(114,9,183,0.1) 0%, transparent 70%)' 
              : 'radial-gradient(circle, rgba(114,9,183,0.05) 0%, transparent 70%)',
            zIndex: 0
          }} />
          
          <Box sx={{ 
            maxWidth: '1400px', 
            mx: 'auto', 
            px: { xs: 2, md: 4 },
            position: 'relative',
            zIndex: 1
          }}>
            <Box sx={{ 
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 6,
              flexDirection: { xs: 'column', sm: 'row' },
              textAlign: { xs: 'center', sm: 'left' }
            }}>
              <Box sx={{ mb: { xs: 2, sm: 0 } }}>
                <Typography variant="h4" sx={{ 
                  fontWeight: 'bold',
                  color: darkMode ? '#fff' : '#333',
                  mb: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: { xs: 'center', sm: 'flex-start' }
                }}>
                  <Box sx={{ 
                    background: '#7209b7',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mr: 2
                  }}>
                    <Business sx={{ color: '#fff' }} />
                  </Box>
                  Верифицирани Салони
                </Typography>
                <Typography variant="body1" sx={{ 
                  color: darkMode ? '#aaa' : '#666',
                  fontSize: { xs: '0.9rem', md: '1rem' }
                }}>
                  Најдобрите Авто Салони и Плацеви во Македонија
                </Typography>
              </Box>
              <Button 
                component={Link}
                to="/all-salons"
                variant="outlined"
                sx={{ 
                  color: '#7209b7',
                  borderColor: '#7209b7',
                  fontWeight: '600',
                  px: 3,
                  py: 1,
                  borderRadius: '12px',
                  '&:hover': { 
                    borderColor: '#7209b7',
                    background: 'rgba(114,9,183,0.1)'
                  }
                }}
              >
                Види ги сите
              </Button>
            </Box>
            
            <Grid container spacing={3}>
              {topDealers.slice(0, 6).map((dealer) => (
                <Grid item xs={6} sm={4} md={2} key={dealer.id}>
                  <Card sx={{ 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    background: darkMode ? '#1e1e1e' : '#fff',
                    borderRadius: '12px',
                    p: 2,
                    textAlign: 'center',
                    border: 'none',
                    boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
                    }
                  }}>
                    <Box sx={{ 
                      width: '100%',
                      height: '60px',
                      mb: 2,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative'
                    }}>
                      <Box sx={{
                        position: 'absolute',
                        top: -8,
                        right: -8,
                        background: '#7209b7',
                        color: '#fff',
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1
                      }}>
                        <Check sx={{ fontSize: '0.7rem' }} />
                      </Box>
                      <img 
                        src={dealer.logo} 
                        alt={dealer.name}
                        style={{ 
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                          filter: darkMode ? 'brightness(0.9)' : 'none'
                        }}
                      />
                    </Box>
                    
                    <Typography variant="subtitle1" sx={{ 
                      fontWeight: 'bold',
                      mb: 1,
                      color: darkMode ? '#fff' : '#333',
                      fontSize: '0.8rem'
                    }}>
                      {dealer.dealerName}
                    </Typography>
                    
                    <Typography variant="body2" sx={{ 
                      mb: 1.5,
                      color: darkMode ? '#aaa' : '#666',
                      fontSize: '0.7rem'
                    }}>
                      {dealer.city || 'Скопје'}
                    </Typography>
                    
                    <Typography variant="body2" sx={{ 
                      mb: 2,
                      color: darkMode ? '#aaa' : '#666',
                      fontSize: '0.7rem'
                    }}>
                      {dealer.adsCount} огласи
                    </Typography>
                    
                    <Button 
                      component={Link}
                      to={`/dealers/${dealer.id}`}
                      variant="contained"
                      size="small"
                      sx={{ 
                        mt: 'auto',
                        background: 'linear-gradient(45deg, #7209b7, #560bad)',
                        color: '#fff',
                        fontWeight: '600',
                        fontSize: '0.7rem',
                        borderRadius: '6px',
                        '&:hover': {
                          background: 'linear-gradient(45deg, #5d0895, #450988)'
                        }
                      }}
                    >
                      Види Понуди
                    </Button>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>

        {/* Listings Tabs Section - Redesigned */}
        <Box sx={{ 
          py: 8, 
          maxWidth: '1400px', 
          mx: 'auto', 
          px: { xs: 2, md: 4 },
          position: 'relative'
        }}>
          <Box sx={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: '300px',
            height: '300px',
            background: darkMode 
              ? 'radial-gradient(circle, rgba(247,37,133,0.1) 0%, transparent 70%)' 
              : 'radial-gradient(circle, rgba(247,37,133,0.05) 0%, transparent 70%)',
            zIndex: 0
          }} />
          
          <Box sx={{ position: 'relative', zIndex: 1 }}>
            <Box sx={{ 
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 4,
              flexDirection: { xs: 'column', sm: 'row' },
              textAlign: { xs: 'center', sm: 'left' }
            }}>
              <Typography variant="h4" sx={{ 
                fontWeight: 'bold',
                color: darkMode ? '#fff' : '#333',
                mb: { xs: 2, sm: 0 }
              }}>
                Најнови Огласи
              </Typography>
              
              <ButtonGroup variant="outlined" sx={{ 
                borderRadius: '12px',
                '& .MuiButton-root': {
                  borderColor: darkMode ? '#555' : '#ddd',
                  color: darkMode ? '#fff' : '#333',
                  '&:hover': {
                    borderColor: '#f72585',
                    color: '#f72585',
                    backgroundColor: 'transparent'
                  }
                }
              }}>
                <Button 
                  onClick={() => setTabValue(0)}
                  sx={{ 
                    bgcolor: tabValue === 0 ? '#f72585' : 'transparent',
                    color: tabValue === 0 ? '#fff' : 'inherit',
                    '&:hover': {
                      bgcolor: tabValue === 0 ? '#d61f74' : 'transparent'
                    }
                  }}
                >
                  Сите
                </Button>
                <Button 
                  onClick={() => setTabValue(1)}
                  sx={{ 
                    bgcolor: tabValue === 1 ? '#f72585' : 'transparent',
                    color: tabValue === 1 ? '#fff' : 'inherit',
                    '&:hover': {
                      bgcolor: tabValue === 1 ? '#d61f74' : 'transparent'
                    }
                  }}
                >
                  Нови
                </Button>
                <Button 
                  onClick={() => setTabValue(2)}
                  sx={{ 
                    bgcolor: tabValue === 2 ? '#f72585' : 'transparent',
                    color: tabValue === 2 ? '#fff' : 'inherit',
                    '&:hover': {
                      bgcolor: tabValue === 2 ? '#d61f74' : 'transparent'
                    }
                  }}
                >
                  Половни
                </Button>
                <Button 
                  onClick={() => setTabValue(3)}
                  sx={{ 
                    bgcolor: tabValue === 3 ? '#f72585' : 'transparent',
                    color: tabValue === 3 ? '#fff' : 'inherit',
                    '&:hover': {
                      bgcolor: tabValue === 3 ? '#d61f74' : 'transparent'
                    }
                  }}
                >
                  Изнајми
                </Button>
              </ButtonGroup>
            </Box>
            
            <Grid container spacing={3}>
              {tabListings[tabValue]?.slice(0, 12).map((car) => (
                <Grid item xs={6} sm={4} md={3} lg={2} key={car.id}>
                  <Card sx={{ 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    background: darkMode ? '#1e1e1e' : '#fff',
                    border: 'none',
                    boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': {
                      transform: 'translateY(-5px)',
                      boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
                    }
                  }}>
                    <Box sx={{
                      position: 'relative',
                      height: '120px',
                      overflow: 'hidden'
                    }}>
                      <CardMedia
                        component="img"
                        height="120"
                        image={
                          car.coverImage ||
                          (car.images && car.images.length > 0
                            ? car.images?.[car.coverPhotoIndex || 0]
                            : 'https://source.unsplash.com/random/600x400/?car')
                        }
                        alt={car.model}
                        sx={{ 
                          objectFit: 'cover',
                          transition: 'transform 0.5s',
                          '&:hover': {
                            transform: 'scale(1.1)'
                          }
                        }}
                      />
                      {car.isPremium && (
                        <Box sx={{
                          position: 'absolute',
                          top: 6,
                          left: 6,
                          background: 'rgba(0,0,0,0.7)',
                          color: '#fff',
                          px: 1,
                          py: 0.2,
                          borderRadius: '50px',
                          display: 'flex',
                          alignItems: 'center'
                        }}>
                          <Star sx={{ 
                            color: '#FFD700',
                            fontSize: '0.8rem',
                            mr: 0.5
                          }} />
                          <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '0.6rem' }}>
                            Премиум
                          </Typography>
                        </Box>
                      )}
                    </Box>
                    <CardContent sx={{ flexGrow: 1, p: 1.5 }}>
                      <Box sx={{ 
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        mb: 0.5
                      }}>
                        <Box>
                          <Typography variant="subtitle2" sx={{ 
                            fontWeight: 'bold',
                            color: darkMode ? '#fff' : '#333',
                            fontSize: '0.75rem',
                            lineHeight: 1.2
                          }}>
                            {car.brand} {car.model}
                          </Typography>
                          <Typography variant="caption" sx={{ 
                            color: darkMode ? '#aaa' : '#666',
                            fontSize: '0.65rem'
                          }}>
                            {car.year} год.
                          </Typography>
                        </Box>
                        <Avatar 
                          sx={{ 
                            width: 24, 
                            height: 24,
                            bgcolor: car.sellerType === 'dealer' ? '#4CAF50' : '#7209b7',
                            fontSize: '0.7rem',
                            fontWeight: 'bold'
                          }}
                        >
                          {car.sellerType === 'dealer' ? 
                            (car.dealerName ? car.dealerName.charAt(0).toUpperCase() : 'A') : 
                            (car.sellerName ? car.sellerName.charAt(0).toUpperCase() : 'P')}
                        </Avatar>
                      </Box>
                      
                      <Typography variant="body2" sx={{ 
                        color: '#3a86ff',
                        fontWeight: 'bold',
                        fontSize: '0.8rem',
                        mb: 1,
                        mt: 0.5
                      }}>
                        {car.price}
                      </Typography>
                      
                      <Box sx={{ 
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 0.5,
                        mb: 0.5
                      }}>
                        {car.mileage && (
                          <Chip 
                            label={car.mileage}
                            size="small"
                            sx={{ 
                              background: darkMode ? '#333' : '#f0f0f0',
                              color: darkMode ? '#fff' : '#333',
                              fontSize: '0.6rem',
                              height: '18px'
                            }}
                          />
                        )}
                        {car.fuelType && (
                          <Chip 
                            label={car.fuelType}
                            size="small"
                            sx={{ 
                              background: darkMode ? '#333' : '#f0f0f0',
                              color: darkMode ? '#fff' : '#333',
                              fontSize: '0.6rem',
                              height: '18px'
                            }}
                          />
                        )}
                      </Box>
                    </CardContent>
                    <CardActions sx={{ p: 1.5, pt: 0 }}>
                      <Button 
                        component={Link}
                        to={`/cars/${car.id}`}
                        fullWidth 
                        variant="contained"
                        size="small"
                        sx={{
                          background: 'linear-gradient(45deg, #f72585, #b5179e)',
                          color: '#fff',
                          fontWeight: '600',
                          fontSize: '0.65rem',
                          py: 0.3,
                          borderRadius: '6px',
                          '&:hover': {
                            background: 'linear-gradient(45deg, #d61f74, #9b1487)'
                          }
                        }}
                      >
                        Види Детали
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <Box sx={{ textAlign: 'center', mt: 6 }}>
              <Button 
                component={Link}
                to={tabValue === 0 ? '/all-cars' : 
                    tabValue === 1 ? '/new' : 
                    tabValue === 2 ? '/used' : '/rentals'}
                variant="contained"
                sx={{ 
                  background: 'linear-gradient(45deg, #f72585, #b5179e)',
                  color: '#fff',
                  fontWeight: '600',
                  px: 4,
                  py: 1.2,
                  fontSize: { xs: '0.8rem', sm: '0.9rem' },
                  borderRadius: '12px',
                  boxShadow: '0 5px 15px rgba(247,37,133,0.4)',
                  '&:hover': {
                    background: 'linear-gradient(45deg, #d61f74, #9b1487)',
                    transform: 'translateY(-2px)'
                  },
                  transition: 'all 0.3s'
                }}
              >
                Види ги сите {tabValue === 0 ? 'Огласи' : 
                             tabValue === 1 ? 'Нови Автомобили' : 
                             tabValue === 2 ? 'Половни Автомобили' : 'Коли за Изнајмување'}
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Call to Action */}
        <Box sx={{ 
          py: 10,
          background: darkMode 
            ? 'linear-gradient(135deg, #121212 0%, #1e1e1e 100%)' 
            : 'linear-gradient(135deg, #f5f5f5 0%, #fff 100%)',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <Box sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: 'radial-gradient(circle at 30% 50%, rgba(58,134,255,0.1) 0%, transparent 30%)',
            zIndex: 0
          }} />
          
          <Box sx={{ 
            maxWidth: '800px', 
            mx: 'auto', 
            px: 3,
            position: 'relative',
            zIndex: 1
          }}>
            <Typography variant="h3" sx={{ 
              fontWeight: 'bold',
              mb: 3,
              color: darkMode ? '#fff' : '#333',
              fontSize: { xs: '1.8rem', md: '2.2rem' }
            }}>
              Готови сте да го продадете вашиот автомобил?
            </Typography>
            
            <Typography variant="body1" sx={{ 
              mb: 4,
              color: darkMode ? '#aaa' : '#666',
              fontSize: { xs: '0.9rem', md: '1rem' }
            }}>
              Објавете го вашиот оглас денес и достигнете до илјадници потенцијални купувачи.
            </Typography>
            
            <Button 
              variant="contained"
              size="large"
              onClick={() => {
                if (!currentUser) {
                  navigate('/login', { state: { from: { pathname: '/post-ad' } } });
                } else {
                  navigate('/post-ad');
                }
              }}
              sx={{ 
                minWidth: '220px',
                background: 'linear-gradient(45deg, #3a86ff, #4361ee)',
                color: '#fff',
                fontWeight: '600',
                fontSize: { xs: '0.9rem', md: '1rem' },
                py: 1.2,
                borderRadius: '12px',
                boxShadow: '0 5px 15px rgba(58,134,255,0.4)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #2667cc, #3a56d6)',
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s'
              }}
            >
              Објави Оглас
            </Button>
          </Box>
        </Box>
      </Box>
    );
  };

  if (!isAuthChecked) {
    return <div style={{ textAlign: 'center', marginTop: '100px' }}>Се вчитува...</div>;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cars/:id" element={<CarDetailsPage />} />
        <Route path="/new" element={<NewCars />} />
        <Route path="/used" element={<UsedCars />} />
        <Route path="/rentals" element={<Rentals />} />
        <Route path="/post-ad" element={<PostAd />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/user" element={<UserPage />} />
        <Route path="/autosalon" element={<AutoSalonPage />} />
        <Route path="/all-cars" element={<AllCars />} />
        <Route path="/all-salons" element={<AllSalons />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/premium" element={<PremiumListings />} />
       
        <Route path="/edit-ad/:adId" element={<EditAd />} />

        {/* 👇 Ова мора да е последно */}
        <Route path="/:dealerSlug" element={<DealerPage />} />
      </Routes>
    </Layout>
  );
}

export default AppWrapper;